import React from "react";
import { useQuery, gql } from "@apollo/client";
import {
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import { XIcon } from "@heroicons/react/solid";
import { parseShowDate, parseShowTime } from "../libraries/time.jsx";
import showPlaceholder from "../img/show-placeholder.jpg";

const Show = () => {
  const history = useHistory();
  let { cardId } = useParams();
  const FIND_SHOW = gql`
  {
  findShowByID (id: ${cardId}) {
    _id
    name
    start_time
    end_time
    thumbnail
    description
    venue {
      name
      lat
      long
      placeId
    }
  }
}
`;
  const { data, loading, error } = useQuery(FIND_SHOW);
  if (loading) {
    return "Loading...";
  }
  if (error) return `Error! ${error}`;
  let showData = data.findShowByID;

  const gapi = window.gapi;

  const googleKey = process.env.REACT_APP_GOOGLE_KEY;
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  const DISCOVERY_DOCS = [
    "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
  ];
  const SCOPES = "https://www.googleapis.com/auth/calendar";

  const handleCalendarClick = () => {
    gapi.load("client:auth2", () => {
      console.log("loaded client");
      gapi.client.init({
        apiKey: googleKey,
        clientId: googleClientId,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
      });
      gapi.client.load("calendar", "v3", () => {
        console.log("boom");
      });
      gapi.auth2
        .getAuthInstance()
        .signIn()
        .then(() => {
          const show = {
            summary: `${showData.name} - @ ${showData.venue.name}`,
            location: "800 Howard St., San Francisco, CA 94103",
            description: "Artt App event description",
            start: {
              dateTime: "2020-02-20T17:00:00.000Z",
              timeZone: "America/Los_Angeles",
            },
            end: {
              dateTime: "2020-03-20T18:00:00.000Z",
              timeZone: "America/Los_Angeles",
            },
            recurrence: ["RRULE:FREQ=DAILY;COUNT=2"],
            attendees: [],
            reminders: {
              useDefault: false,
              overrides: [
                { method: "email", minutes: 24 * 60 },
                { method: "popup", minutes: 10 },
              ],
            },
          };
          const request = gapi.client.calendar.events.insert({
            calendarId: "primary",
            resource: show,
          });

          request.execute((event) => {
            window.open(event.htmlLink);
          });
        });
    });
  };

  return (
    <div className="glass rounded-t-md relative">
      <XIcon
        className="absolute w-8 h-8 top-2 right-2 z-10"
        onClick={() => history.goBack()}
      />
      <div className="px-2 mb-2">
        <p className="razz">{showData.name}</p>
        <p className="text-xl">@ {showData.venue.name}</p>
      </div>
      <img className="w-full" src={showData.thumbnail} alt="" />
      <div className="px-2 mb-4">
        <div className="mb-2 text-xl">
          {parseShowDate(showData.start_time)}
          <div className="flex">
            <p className="text-2xl">
              {parseShowTime(showData.start_time)}
              <span className="mx-2">—</span>
              {parseShowTime(showData.end_time)}
            </p>
          </div>
        </div>
        <div className="flex mb-4">
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${showData.venue.lat}%2C${showData.venue.long}&query_place_id=${showData.venue.placeId}`}
            target="_blank"
            rel="noreferrer"
          >
            <button className="py-2 px-4 bg-blue-500 text-white font-semibold rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">
              directions
            </button>
          </a>
          <button
            hidden
            onClick={handleCalendarClick}
            className="ml-4 py-2 px-4 bg-white text-blue-500 border-2 border-blue-500 font-semibold rounded-md shadow-md hover:bg-blue-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
          >
            + to calendar
          </button>
        </div>
        <p>
          {showData.description
            ? showData.description
            : `It’s all a game of angles. Absolutely no pressure. You are just a
          whisper floating across a mountain. A fan brush is a fantastic piece
          of equipment. Use it. Make friends with it. Everything’s not great in
          life, but we can still find beauty in it.`}
        </p>
      </div>
    </div>
  );
};

//Events list

export const ListShows = (props) => {
  const history = useHistory();
  let { path, url } = useRouteMatch();

  const GET_SHOWS = gql`
    {
      getShows {
        data {
          _id
          name
          start_time
          end_time
          thumbnail
          venue {
            name
          }
        }
      }
    }
  `;

  const { data, loading, error } = useQuery(GET_SHOWS);

  if (loading) {
    return "Loading...";
  }
  if (error) return `Error! ${error}`;

  const dateRangeFilter = (startDate, endDate, shows) => {
    return shows.filter(
      (obj) =>
        new Date(startDate) <= new Date(obj.start_time) &&
        new Date(endDate) >= new Date(obj.start_time)
    );
  };
  let dateRangeStart = props.value[0];
  let dateRangeEnd = props.value[1];
  let filteredShows = dateRangeFilter(
    dateRangeStart,
    dateRangeEnd,
    data.getShows.data
  );
  //console.log(filteredShows);

  return (
    <div className="pt-32 h-screen overflow-y-auto lg:w-1/3 lg:pt-20">
      <Switch>
        <Route exact path={path}>
          <div className="glass rounded-t-md pt-2 relative">
            <XIcon
              className="absolute w-8 h-8 top-2 right-2 z-10"
              onClick={() => history.goBack()}
            />
            <p className="px-2 pb-4 text-xl">Upcoming Events</p>
            <ul className="space-y-3 px-2">
              {filteredShows.map((show) => {
                return (
                  <li
                    className="bg-white shadow overflow-hidden rounded-md"
                    key={show._id}
                  >
                    <Link className="flex" to={`${url}/${show._id}`}>
                      <div
                        className="w-1/4 rounded-l-md bg-cover bg-center"
                        style={{ backgroundImage: `url(${show.thumbnail})` }}
                      ></div>
                      <div className="px-6 py-1 pb-4">
                        {/* <p className="text-gray-700 border-b">
                          {show.venue.name}
                        </p> */}
                        <p className="line-clamp-1 razz mb-4">{show.name}</p>
                        {parseShowDate(show.start_time)}
                        <div className="flex">
                          <p className="text-2xl">
                            {parseShowTime(show.start_time)}
                            <span className="mx-2">—</span>
                            {parseShowTime(show.end_time)}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </Route>
        <Route path={`${path}/:cardId`}>
          <Show />
        </Route>
      </Switch>
    </div>
  );
};
